import React from 'react';
import { Icon } from '../../elements/icon';

/**
 * GDPR consent: must expose a real checkbox in the DOM so quizValidation
 * (`document.querySelector('#agree:checked')`) and native accessibility work.
 */
const GdprCheckbox = ({ id = 'agree', checked, onChange, label }) => {
  return (
    <label
      htmlFor={id}
      className="t-flex t-items-start t-gap-2.5 t-mt-4 t-cursor-pointer t-relative t-z-10"
    >
      <input
        type="checkbox"
        id={id}
        name={id}
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        className="t-sr-only t-peer"
        aria-checked={!!checked}
      />
      <span
        aria-hidden
        className={`t-w-5 t-h-5 t-min-w-[20px] t-mt-0.5 t-flex t-shrink-0 t-items-center t-justify-center t-rounded-[5px] t-border-2 t-transition-colors t-pointer-events-none peer-focus-visible:t-ring-2 peer-focus-visible:t-ring-quiz-teal peer-focus-visible:t-ring-offset-2 ${
          checked ? 't-border-quiz-teal t-bg-quiz-teal' : 't-border-g300 t-bg-white'
        }`}
      >
        <Icon
          name="tick"
          size={11}
          color="#fff"
          raw
          className={checked ? 't-opacity-100' : 't-opacity-0'}
        />
      </span>
      <span className="t-text-[13px] t-leading-relaxed t-text-g500 t-select-none">{label}</span>
    </label>
  );
};

export default GdprCheckbox;
